interface MWCGoodsNo {
  number: string;
  colorCode: string;
  sizeCode: string;
}

interface MWCCartAPIURL {
  leftGoodsNo: string;
  rightGoodsNo: string;
}

export const mwcGoodsNo = ({ number, colorCode, sizeCode }: MWCGoodsNo) => {
  return `${number}${colorCode}${sizeCode}`;
};

export const mwcCartAPIURL = ({ leftGoodsNo, rightGoodsNo }: MWCCartAPIURL) => {
  return leftGoodsNo === rightGoodsNo
    ? `${import.meta.env.VITE_MWC_API_FQDN}/voi/webcatalog/2.0/maruiRelatedSiteMultiUpdateCart.do?goodsNo=${leftGoodsNo}&ins=ideal`
    : `${import.meta.env.VITE_MWC_API_FQDN}/voi/webcatalog/2.0/maruiRelatedSiteMultiUpdateCart.do?goodsNo=${leftGoodsNo},${rightGoodsNo}&ins=ideal`;
};
